/**
 * Rend inerte tout ce qui n'est pas l'ecran de verrou : ni clic, ni focus clavier, ni lecteur d'ecran.
 *
 * Les dialogues et menus PrimeNG sont ajoutes sous `<body>`, hors de l'arbre de l'application : un
 * `inert` pose sur le seul conteneur de l'app les laisserait atteignables. On parcourt donc les enfants
 * de `<body>` ET ceux de l'hote de l'application, sauf l'ecran de verrou lui-meme.
 *
 * `suivis` garde ce qu'on a rendu inerte, pour ne rien retirer qu'on n'ait pose.
 */
export function appliquerInerte(actif: boolean, hote: HTMLElement, ecran: string, suivis: Set<Element>): void {
  if (!actif) {
    for (const el of suivis) el.removeAttribute('inert');
    suivis.clear();
    return;
  }
  const doc = hote.ownerDocument;
  const candidats = [...Array.from(doc.body.children), ...Array.from(hote.children)];
  for (const el of candidats) {
    if (el === hote || el.tagName.toLowerCase() === ecran || el.contains(hote)) continue;
    if (el.hasAttribute('inert') && !suivis.has(el)) continue; // deja inerte pour une autre raison
    el.setAttribute('inert', '');
    suivis.add(el);
  }
}
